// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "dddb54ceb3f16c6c75ee67f35081c111d0b3657f/static/css/" + chunkId + "." + "9ae35b6f" + ".chunk.css";
};